import { Link } from "react-router-dom";
import * as Icons from "heroicons-react";
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import ReportSideBar from "../../Common/SideBar/ReportSideBar";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useCustomerWiseSalesQuery } from "../../../services/reportsApi";
import SelectCustomerReport from "../../Common/CustomSelect/SelectCustomerReport";
import { useWarehouseQuery } from "../../../services/warehouseApi";

const CustomerWiseSalesReport = () => {
  const auth = signInUser();

  const [warehouse, setWarehouse] = useState("allWh");
  const [customerId, setCustomerId] = useState();

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId } = auth;
  const lang = useSelector((state) => state.languageReducer);
  const {
    data: salesData,
    isLoading,
    isError,
    error,
  } = useCustomerWiseSalesQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
    customerId,
  });

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");
  
  const { data: wh, refetch } = useWarehouseQuery(warehouse);
  
  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);
  
  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name);  // Directly set the name, no need for optional chaining here
    }
  }, [wh]);
  // console.log("Customer Wise Sales Report Data:", salesData);


// Export CSV
  const handleExportCSV = () => {
    if (!salesData || salesData.length === 0) {
      alert("No data available for export.");
      return;
    }
  
    const start = new Date(startDate).toLocaleString();  
    const end = new Date(endDate).toLocaleString();  
    // const end = salesData[salesData.length - 1]?.createdAt;
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";
  
    const storeName = auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportTitle = "Customer Wise Sales Report";
  
    const headerInfo = [
      `,Store: ${storeName},,,,,Warehouse: ${warehouseName}`,
      `,Report: ${reportTitle},,,,,Date Range: ${start} to ${end}`,
      `,Generated On: ${generatedOn},,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];
    
  
    const csvTableHeader = [
      "S/N",
      "Invoice No",
      "Date",
      "Customer Name",
      "Phone",
      "Membership",
      "Total Items",
      "Gross Total",
      "Discount",
      "Total",
      "Received",
      "Change",
    ].join(",");
  
    let totalItems = 0;
    let totalGross = 0;
    let totalDiscount = 0;
    let totalAmount = 0;
    let totalReceived = 0;
    let totalChange = 0;
  
    const csvRows = salesData.map((row, index) => {
      const items = Number(row?.totalItem ?? row?.totalItems ?? 0);
      const gross = Number(row?.grossTotal || 0);
      const discount = Number(row?.promoDiscount ?? row?.discount ?? 0);
      const total = Number(row?.total || 0);
      const received = Number(row?.totalReceived ?? row?.received ?? 0);
      const change = Number(row?.changeAmount ?? row?.change ?? 0);
  
      totalItems += items;
      totalGross += gross;
      totalDiscount += discount;
      totalAmount += total;
      totalReceived += received;
      totalChange += change;
  
      return [
        index + 1,
        `"${row?.invoiceNo || ""}"`,
        `"${row?.createdAt || ""}"`,
        `"${row?.customerName || ""}"`,
        `"${row?.customerPhone || ""}"`,
        `"${row?.customerMembership || row?.membership || "N/A"}"`,
        items,
        gross.toFixed(2),
        discount.toFixed(2),
        total.toFixed(2),
        received.toFixed(2),
        change.toFixed(2),
      ].join(",");
    });
  
    // Summary section styled like a box
    const summaryLabelRow = [
      "", "", "", "", "", "","", "",
      "** TOTAL SUMMARY **",
    ].join(",");
  
    const summaryHeaderRow = [
      "", "", "", "", "", "",
      "Total Items",
      "Gross Total",
      "Discount",
      "Total",
      "Received",
      "Change",
    ].join(",");
  
    const summaryDataRow = [
      "", "", "", "", "", "",
      totalItems,
      totalGross,
      totalDiscount,
      totalAmount,
      totalReceived,
      totalChange,
    ].join(",");
  
    const csvContent = [
      ...headerInfo,
      csvTableHeader,
      ...csvRows,
      "", // empty line for separation
      "", // empty line for separation
      "", // empty line for separation
      summaryLabelRow,
      summaryHeaderRow,
      summaryDataRow,
    ].join("\n");
  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CustomerWiseSalesReport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  

// export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");
  
    if (salesData?.length === 0) {
      alert("No sales data found.");
      return;
    }
  
    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();
  
    const storeName = auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "Sales Wise Customer Summary Report";
  
    // Title
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });
  
    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });
  
    // Header info - Justify between
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39,);
    // doc.text(`Report: ${reportName}`, 140, 28, { align: "center" });
    doc.text(`Generated At: ${reportGeneratedAt}`, 280, 28, { align: "right" });
    doc.text(`Generated By: ${auth?.name}`, 280, 33, { align: "right" });
  
    // Table header
    const headers = [
      [
        "S/N",
        "Invoice No",
        "Date",
        "Customer Name",
        "Phone",
        "Membership",
        "Total Items",
        "Gross Total",
        "Discount",
        "Total",
        "Received",
        "Change",
      ],
    ];
  
    const data = salesData.map((item, index) => [
      index + 1,
      item?.invoiceNo || "N/A",
      item?.createdAt || "N/A",
      item?.customerName || "N/A",
      item?.customerPhone || "N/A",
      item?.customerMembership || "N/A",
      Number(item?.totalItem || 0),
      Number(item?.grossTotal || 0).toFixed(2),
      Number(item?.promoDiscount || 0).toFixed(2),
      Number(item?.total || 0).toFixed(2),
      Number(item?.totalReceived || 0).toFixed(2),
      Number(item?.changeAmount || 0).toFixed(2),
    ]);
  
    autoTable(doc, {
      head: headers,
      body: data,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 9,
        halign: "center",
      },
      headStyles: {
        fillColor: [242, 101, 45], // tomato background
        textColor: [255, 255, 255], // white text
        fontStyle: "bold",
        lineWidth: 0.2,  // line thickness
        lineColor: [255, 255, 255],  // white border color
      
      },
    });
    
// === Summary Box ===
const finalY = doc.lastAutoTable.finalY + 10;
const lineHeight = 6; // smaller line height
const numberOfRows = 7;
const extraLineHeight = 1.5;
const boxHeight = numberOfRows * lineHeight + extraLineHeight * lineHeight + 10;
const boxWidth = 100; // smaller width

// Position it to the right side
const pageWidth = doc.internal.pageSize.getWidth();
const boxX = pageWidth - boxWidth - 15;
const boxY = finalY;

// Draw dotted border
doc.setLineDashPattern([1, 1], 0);
doc.rect(boxX, boxY, boxWidth, boxHeight);
doc.setLineDashPattern([], 0); // reset to solid

let y = boxY + 10;
const labelX = boxX + 5;
const valueX = boxX + boxWidth - 5;
doc.setFontSize(9);

// Calculations
const totalGross = sumField(salesData, "grossTotal");
const totalDiscount = sumField(salesData, "promoDiscount");
const totalAmount = sumField(salesData, "total");
const totalReceived = sumField(salesData, "totalReceived");
const totalVAT = sumField(salesData, "vat");

const gpAmount = (totalAmount - totalGross).toFixed(2);
const grossNum = parseFloat(totalGross) || 0;
const gpPercent = grossNum > 0 ? ((parseFloat(gpAmount) / grossNum) * 100).toFixed(2) : "0.00";
const saleWithoutVAT = (totalAmount - totalVAT).toFixed(2);

// Row 1: Total Cost Amount
doc.text("Total Cost Amount :", labelX, y);
doc.text(`${totalGross}`, valueX, y, { align: "right" });

// Row 2: Total Net Amount
y += lineHeight;
doc.text("Total Net Amount :", labelX, y);
doc.text(`${totalAmount}`, valueX, y, { align: "right" });

// Row 3: Total VAT Amount
y += lineHeight;
doc.text("Total VAT Amount :", labelX, y);
doc.text(`${totalVAT}`, valueX, y, { align: "right" });

// Row 4: Sale Without VAT
y += lineHeight;
doc.text("Sale Without VAT :", labelX, y);
doc.text(`${saleWithoutVAT}`, valueX, y, { align: "right" });

// Row 5: Warning Message
y += lineHeight;
doc.setTextColor(242, 101, 45);
doc.setFont(undefined, "bold");
doc.text(
  "** Return Adjusted **",
  boxX + boxWidth / 2,
  y,
  { align: "center" }
);
doc.setTextColor(0, 0, 0);
doc.setFont(undefined, "normal");

// Row 6: GP Amount
y += lineHeight;
doc.text("GP Amount :", labelX, y);
doc.text(`${gpAmount}`, valueX, y, { align: "right" });

// Row 7: GP %
y += lineHeight;
doc.text("GP % :", labelX, y);
doc.text(`${gpPercent}%`, valueX, y, { align: "right" });

  
    // Save the PDF
    doc.save("SalesSummary.pdf");
  };
  
  
  // Utility to sum values from objects
  const sumField = (data, field) =>
    data.reduce((acc, item) => acc + (parseFloat(item[field]) || 0), 0).toFixed(2);
  

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> Customer Wise Sales Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className="d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
          <SelectCustomerReport
            aamarId={aamarId}
            onCustomerSelect={setCustomerId}
          />
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerWiseSalesReport;
